import { ApiError } from 'redux-api-middleware'
import { expiredSession } from '../../actions/user'

/**
 * API errors handler
 */
export default (store) => (next) => (action) => {
    const { dispatch } = store
    const { payload } = action

    if (payload instanceof ApiError) {
        const { status } = payload

        switch (status) {
            // Unauthenticated
            case 401:
                next(action)
                return dispatch(expiredSession())
            default:
        }
    }
    return next(action)
}
